<script>
export default {
    type: "column2d",
    width: "100%",
    height: "350",
    dataFormat: "json",
    dataSource: {
        chart: {
            // caption: "Countries With Most Oil Reserves [2017-18]",
            // subcaption: "In MMbbl = One Million barrels",
            showvalues: "1",
            xaxisname: "Jenis Kutipan Hasil",
            yaxisname: "Jumlah Kutipan Hasil",
            // numbersuffix: "K",
            numberprefix: "RM",
            theme: "fusion",
        },
        data: [
            {
                label: "PULANG BALIK PERBELANJAAN",
                value: "110",
                "color": "#FF9F45",
            },
            {
                label: "TERIMAAN DARI AGENSI KERAJAAN",
                value: "80",
                "color": "#F76E11",
            },
            {
                label: "SUMBANGAN DARIPADA AGENSI KERAJAAN",
                value: "125",
                "color": "#FFBC80",
            },
        ],
    },
};
</script>
